import View from './view.js'
import icons from 'url:../../img/icons.svg'
import { RES_PER_PAGE } from '../config.js'

class addRecipeView extends View {
    _parentElement = document.querySelector('.upload');
    _successMessage = `Recipe was successfully uploaded`

    _window = document.querySelector('.add-recipe-window')
    _overlay = document.querySelector('.overlay')
    _btnOpen = document.querySelector('.nav__btn--add-recipe')
    _btnClose = document.querySelector('.btn--close-modal')

    constructor() {
        super();
        this._addHandlertShowWinodw();
        this._addHandlertHideWinodw();
    }

    _addHandlertShowWinodw() {
        this._btnOpen.addEventListener('click', this.toggleWindow.bind(this));

    }
    toggleWindow() {
        this._overlay.classList.toggle('hidden');
        this._window.classList.toggle('hidden');
    }
    _addHandlertHideWinodw() {
        this._btnClose.addEventListener('click', this.toggleWindow.bind(this));
        this._overlay.addEventListener('click', this.toggleWindow.bind(this));
    }
    _addHandlerUpload(handler) {
        this._parentElement.addEventListener('submit', function (e) {
            e.preventDefault()
            const dataArr = [...new FormData(this)]
            const data = Object.fromEntries(dataArr);  //this make the array of entries to an object
            handler(data)
        })
    }
    _generateMarkup() { }



}


export default new addRecipeView();